// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__2YNOD","dashboards":"Dashboard_dashboards__AssQj","dash1":"Dashboard_dash1__Smp94","dash2":"Dashboard_dash2__N1uq-"};